var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02Instagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.1,0C0.9,0,0,0.9,0,2.1v3.3c0,1.2,0.9,2.1,2.1,2.1h3.3c1.2,0,2.1-0.9,2.1-2.1V2.1C7.5,0.9,6.6,0,5.4,0H2.1z  M6.2,0.8c0.2,0,0.4,0.2,0.4,0.4S6.5,1.7,6.2,1.7S5.8,1.5,5.8,1.2S6,0.8,6.2,0.8z M3.7,1.7c1.2,0,2.1,0.9,2.1,2.1S4.9,5.8,3.7,5.8 S1.7,4.9,1.7,3.7S2.6,1.7,3.7,1.7z M3.7,2.5c-0.7,0-1.2,0.6-1.2,1.2S3.1,5,3.7,5S5,4.4,5,3.7S4.4,2.5,3.7,2.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Instagram);
export default __webpack_public_path__ + "static/media/02-instagram.df89ee854ccc4f7ed17af8f702669b31.svg";
export { ForwardRef as ReactComponent };